import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { NgClass } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Observable, Subscription } from 'rxjs';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';

@Component({
    selector: 'valben-dropdown-input',
    standalone: true,
    imports: [NgClass, FormsModule, MatFormFieldModule, MatSelectModule],
    templateUrl: './dropdown-input.component.html',
})
export class DropdownInputComponent implements OnInit, OnDestroy {
    @Input() key!: string
    @Input() itemObservable!: () => Observable<any> | undefined
    @Input() update!: (value: any) => void
    @Input() title = ''
    @Input() placeholder = 'Odaberi...'
    @Input() error = false
    @Input() options: any[] = []
    @Input() optionLabel: string | undefined
    @Input() optionValue: string | undefined

    value: any = null;

    private sub?: Subscription;

    ngOnInit(): void {
        this.sub = this.itemObservable()?.subscribe(item => {
            const incoming = item ? item[this.key] ?? null : null;
            if (incoming !== this.value) {
                this.value = incoming;
            }
        });
    }

    onChange(event: any) {
        this.update(event.value);
    }

    ngOnDestroy(): void {
        this.sub?.unsubscribe();
    }
}
